import { lazy } from "react";
async function importRetry(importFunction) {
  return new Promise((resolve) => {
    function onError(error) {
      if (typeof window.console !== "undefined") {
        window.console.error(error);
      }
      if (window.resourceReload) {
        window.resourceReload.onFailed();
      } else {
        const retrySeconds = 5;
        window.setTimeout(() => {
          if (window.resourceReload) {
            window.resourceReload.onFailed();
          } else {
            window.navigateToFatalErrorPage("messageType=connection");
          }
        }, retrySeconds * 1e3);
      }
    }
    try {
      importFunction().then((result) => {
        if (result && typeof result === "object" && Object.prototype.toString.call(result) === "[object Module]") {
          resolve(result);
        } else {
          onError(new Error("Import failed"));
        }
      }).catch(onError);
    } catch (ex) {
      onError(ex);
    }
  });
}
function reactLazyImportRetry(importFunction) {
  return lazy(() => importRetry(importFunction));
}
export {
  importRetry as default,
  reactLazyImportRetry
};
//# sourceMappingURL=importRetry.js.map
